import { type RoleAttribute } from '@gonfalon/resource-specifiers/constants';

import { RoleAttributeFormKind } from '../../types';

export function getRoleAttributeFormKind(attribute: RoleAttribute) {
  if (attribute.tagsRoleAttribute) {
    return RoleAttributeFormKind.TAG;
  }

  if (attribute.viewsRoleAttribute) {
    return RoleAttributeFormKind.VIEW;
  }

  return RoleAttributeFormKind.RESOURCE;
}
